import { Input, Heading, Text, Button } from '@chakra-ui/react';
import { useState } from 'react';
import { resetPassword } from '../../firebase';
import FullPageForm from '../../components/FullPageForm';

function ResetPassword() {
    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [done, setDone] = useState(false);

    return (
        <FullPageForm>
            <Heading marginBottom="30px">Reset your password</Heading>
            <Text>
                Enter the email you signed up for PathMatch with. We'll send you a link to update
                your password.
            </Text>
            <Input
                type="text"
                marginBottom="10px"
                marginTop="20px"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email Address"
            />
            <Button
                width="100%"
                colorScheme="brand"
                disabled={done}
                onClick={() => resetPassword(email, setErrorMessage, setDone)}
            >
                Reset Password
            </Button>
            <Text color="red">{errorMessage}</Text>
            <Text display={done ? 'inline' : 'none'}>Visit email to reset password</Text>
        </FullPageForm>
    );
}

export default ResetPassword;
